<template>
  <div class="actionPlan">
    <div class="add show assessmentAdd">
      <GradeDetail :id="gradeId" :getDatas="getGradeData"></GradeDetail>
      <div class="addBox">
        <div class="title">
          学科行动计划-评估
          <span style="color:#ababab;font-size: 16px;font-weight: normal">（请对任务完成和完成效果打分，分数区间0-100分，分数仅支持正整数）</span>
        </div>
        <ul class="showlist">
          <li v-for="(item,index) in data.subjectStress||[]" :key="index">
            <span>
              <img src="~@img/xueyezixun/public/star.png" alt="">
              {{index}}
            </span>
            <div class="scores">学期目标：{{item?item[0]['targetScore']:''}}</div>
            <div v-for="(it,i) in item" :key="i">
              <div>阶段问题{{it.length>1?i+1:""}}：{{it.stageProblem}}</div>
              <div>阶段任务{{it.length>1?i+1:""}}：{{it.stageTask}}</div>
              <div class="right">
                <div>任务完成：<input type="text" v-model="it.taskComplete">
                </div>
                <div>完成效果：<input type="text" v-model="it.completeEffect">
                </div>
              </div>
            </div>
          </li>
          <li v-for="(item,index) in data.subjectCommon||[]" :key="index">
            <span>
              {{index}}
            </span>
            <div class="scores">学期目标：{{item?item[0]['targetScore']:''}}</div>
            <div v-for="(it,i) in item" :key="i">
              <div>阶段问题{{it.length>1?i+1:""}}：{{it.stageProblem}}</div>
              <div>阶段任务{{it.length>1?i+1:""}}：{{it.stageTask}}</div>
              <div class="right">
                <div>任务完成： <input type="text" v-model="it.taskComplete">
                </div>
                <div>完成效果： <input type="text" v-model="it.completeEffect">
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="title">学习习惯养成</div>
        <div>
          <circleName :name="'阶段学习习惯养成评估:'"></circleName>
          <div class="habit">
            <table v-for="(item,index) in data.subjectLearnHabit||[]" :key="index">
              <tbody>
              <tr>
                <td>阶段问题:</td>
                <td>
                  {{item.stageProblem}}
                </td>
                <td>
                  <span></span>
                  任务完成： <input type="text" v-model="item.taskComplete">
                </td>
              </tr>
              <tr>
                <td>目标习惯:</td>
                <td>
                  {{item.targetHabit}}
                </td>
                <td>
                  <span></span>
                  完成效果： <input type="text" v-model="item.completeEffect">
                </td>
              </tr>
              <tr>
                <td>行动方案：</td>
                <td>
                  {{item.actionPlan}}
                </td>
                <td>
                  <span></span>
                  是否继续：
                  <el-radio v-model="item.isContinue" :label="1"  style="padding-left: 30px">是</el-radio>
                  <el-radio v-model="item.isContinue" :label="2" >否</el-radio>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="title" style="margin-top: 30px">路径条件</div>
        <div>
          <circleName :name="'条件目标:'+data.consultRecord"></circleName>
          <circleName :name="'路径目标任务评估:'"></circleName>
          <div class="habit">
            <table v-for="(item,index) in data.subjectPathCondition||[]" :key="index">
              <tbody>
              <tr>
                <td>阶段目标:</td>
                <td>
                  {{item.stageTarget}}
                </td>
                <td>
                  <span></span>
                  任务完成： <input type="text" v-model="item.taskComplete">
                </td>
              </tr>
              <tr>
                <td>阶段任务:</td>
                <td>
                  {{item.stageTask}}
                </td>
                <td>
                  <span></span>
                  完成效果： <input type="text" v-model="item.completeEffect">
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="bottom" style="width: 300px;margin: 60px auto 0;display: flex;justify-content: space-between">
          <Button name="预览"
                  @handleClick="preview" :style="{borderRadius:'16px'}"></Button>
          <Button name="完成评估"  @handleClick="submit" :style="{borderRadius:'16px'}"></Button>
        </div>
      </div>
    </div>

    <Popup v-if="popup_bool" :inter-view="interView" :get-child-data="true" :getPopupBool="getPopupBool" :getPopupData="getPopupData" ></Popup>
  </div>
</template>
<script>
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
import GradeDetail from './gradeDetailassessment';
import Popup from '@/components/xueyezixun/InterviewPopup'
export default {
  name: 'gradeDetail',
  components:{MessageTitle ,CircleName,SummaryTitle,Button,GradeDetail,Popup  },
  data() {
    if(window.sessionStorage.getItem('actionAssementPreview')){
      return JSON.parse(window.sessionStorage.getItem('actionAssementPreview'))
    }else{
      return {
        actionPlanId: this.$route.query.actionPlanId,
        gradeId: this.$route.query.gradeDetailId,
        studentId:sessionStorage.getItem('myStudentStudentId'),
        data: {},
        subjects: [],
        interView: [{
          category: 4,
          interViewTheme: '行动计划评估'
        }],
        popup_bool:true,
        // popup_bool:false,
        interViewData:'',
      }
    }

  },
  methods:{
    getPopupBool(bool) {
      this.popup_bool= bool
    },
    getPopupData(obj){
      this.interViewData=obj
    },
    getData(){
      console.log(this.$route.query)
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.detail, {
        id:this.$route.query.actionPlanId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          this.data=res.data.data
        }else{

        }
      })
    },
    //筛选科目
    screenSubject(name){
      if (name == '语文') {
        return 1
      }
      if (name == '数学') {
        return 2
      }
      if (name == '外语'|| name == '英语') {
        return 3
      }
      if (name == '物理') {
        return 4
      }
      if (name == '化学') {
        return 5
      }
      if (name == '生物') {
        return 6
      }
      if (name == '历史') {
        return 7
      }
      if (name == '地理') {
        return 8
      }
      if (name == '政治') {
        return 9
      }
      if (name == '技术') {
        return 10
      }
      return 0
    },

    getGradeData(obj){
      if(sessionStorage.getItem('actionAssementPreview')){
        return;
      }
      this.subjects=obj.subject
      let subjectStress = this.data.subjectStress;
      let subjectCommon = this.data.subjectCommon;
      if (subjectStress) {
        obj.subject.forEach(item => {
          Object.keys(subjectStress).forEach(key => {
            if (item.subject == key) {
              subjectStress[key][0].targetScore = item.targetScore
            }
          })
        })
      }
      if (subjectCommon) {
        obj.subject.forEach(item => {
          Object.keys(subjectCommon).forEach(key => {
            if (item.subject == key) {
              subjectCommon[key][0].targetScore = item.targetScore
            }
          })
        })
      }
      this.$set(this.data,'subjectStress',subjectStress)
      this.$set(this.data,'subjectCommon',subjectCommon)
    },
    preview(){
      for(let i=0;i<$('.addBox input[type=number]').length;i++){
        if(!$('.addBox input[type=number]')[i].value){
          this.$message.error("请将数据补充完整")
          return;
        }
      }
      window.sessionStorage.setItem('actionAssementPreview',JSON.stringify(this._data))
      this.$router.push({
        path:'/consultant/minestudent/main/implement/actionplan/assessmentPreview',
        query:this.$route.query
      })
    },
    submit(){
      const {subjectStress,subjectCommon,subjectLearnHabit,subjectPathCondition} = this.data
      const {actionPlanId,interViewData,gradeId} = this
      let subjectStressTransfrom=[],subjectCommonTransfrom=[];
      Object.keys(subjectStress).forEach(item=>{
        subjectStress[item].forEach(it=>{
          subjectStressTransfrom.push(
              {
                id:it.id,
                subject:it.subject,
                taskComplete:it.taskComplete,
                completeEffect:it.completeEffect
              }
          )
        })
      })
      Object.keys(subjectCommon).forEach(item=>{
        subjectCommon[item].forEach(it=>{
          subjectCommonTransfrom.push(
              {
                id:it.id,
                subject:it.subject,
                taskComplete:it.taskComplete,
                completeEffect:it.completeEffect
              }
          )
        })
      })
      subjectLearnHabit&&subjectLearnHabit.forEach(item=>{
        delete item.actionPlan;
        delete item.stageProblem
        delete item.targetHabit;

      })
      subjectPathCondition&&subjectPathCondition.forEach(item=>{
        delete item.stageTarget
        delete item.stageTask
      })
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.assessmentScore, {
        id:actionPlanId,
        interviewRecord:interViewData,
        subjectStress: subjectStressTransfrom,
        subjectCommon:subjectCommonTransfrom,
        subjectLearnHabit:subjectLearnHabit,
        subjectPathCondition:subjectPathCondition
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let data=res.data;
          sessionStorage.removeItem('actionAssementPreview')
          this.$router.push( {path:'/consultant/minestudent/main/implement/actionplan/assessmentShow',
            query:{gradeDetailId:this.gradeId,actionPlanId:data.data.id}})
        }else{

        }
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
<style scoped lang="less">
th{
  font-weight: bolder;
  text-align: center;
  color:#5C5C5C;
}
input{
  width: 100px;
  line-height: 35px;
  height: 35px;
  text-align: center;
  display: inline-block;
}
@import "./css/index.less";
</style>
<style lang="less">
.actionPlan_add_css{

  .el-input__inner{
    border: 1px solid #DCDFE6;
    line-height: 32px;
  }
  .table2{
    .el-input__inner{
      border: none;
      line-height: 32px;
    }
  }

}
</style>